/**
 * TicketedEventWaitlistEntry Entity Schemas
 *
 * Capacity-trigger waitlist for sold-out events.
 */

import { z } from 'zod'

export const TicketedEventWaitlistStatusSchema = z.enum(['waiting', 'notified', 'claimed', 'expired', 'cancelled'])
export type TicketedEventWaitlistStatus = z.infer<typeof TicketedEventWaitlistStatusSchema>

export const TicketedEventWaitlistEntrySchema = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string().nullable(),
  desiredQuantity: z.number().int(),
  status: TicketedEventWaitlistStatusSchema,
  notifiedAt: z.string().nullable(),
  expiresAt: z.string().nullable(),
  claimedAt: z.string().nullable(),
  /**
   * The public claim page for an open offer, so an admin can send it by hand
   * (U13). Set only while the entry is `notified`; null otherwise. Optional so
   * a client built before U13 still parses a payload without it.
   */
  claimUrl: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().nullable()
})
export type TicketedEventWaitlistEntry = z.infer<typeof TicketedEventWaitlistEntrySchema>
